module.exports = __webpack_public_path__ + "img/nav-jbsc.b392363d.png";